import { extend } from "@react-three/fiber";
import { GradientMaterial } from "./GradientMaterial";

// Регистрируем все кастомные материалы
extend({ GradientMaterial });
